import { StyleguideCompanyType, StyleguidePages, StyleguideProjectInfoType } from "./types";

const styleguideAllowedSlugs: Array<StyleguidePages> = ['about', 'guidelines', 'tokens', 'objects', 'components', 'compositions'];

export function styleguideVerifyAllowedSlug(slug: StyleguidePages) {
  if (styleguideAllowedSlugs.indexOf(slug) >= 0) { return true; }
  return false;
}

export function styleguideGetCompanyInfo(company: StyleguideCompanyType) {
  if (company === 'hoppinger') {
    return {
      name: 'Hoppinger',
      url: 'https://www.hoppinger.com'
    }
  } else if (company === 'vidda') {
    return {
      name: 'Vidda Digital',
      url: 'https://www.viddadigital.com'
    }
  } else if (company === 'business') {
    return {
      name: 'Hoppinger Business Solutions',
      url: 'https://business-solutions.hoppinger.com'
    }
  }
  return {
    name: 'Other',
    url: ''
  };
}

export function styleguideGetProjectInfo(project: StyleguideProjectInfoType) {
  if (project.name !== '') {
    return {
      name: project.name,
      src: project.logoSrc
    }
  } else {
    return {
      name: 'Hoppinger',
      src: '/styleguide/images/logo.svg'
    }
  }
}

type StyleguidePlaceholderShapeProps = {
  width: number
  height: number
  radius: string
  bgColor: string
}

type StyleguidePlaceholderTextProps = {
  color: string
  font?: string
}

type StyleguidePlaceholderProps = {
  shape: StyleguidePlaceholderShapeProps,
  text?: StyleguidePlaceholderTextProps
}

const fontSize = (p: StyleguidePlaceholderProps) => p.shape.width * .075 < 10 ? 10 : p.shape.width * .075

// HOW TO USE: <img src={styleguidePlaceholder({ shape: { width: 200, height: 75, radius: '0', bgColor: '#E8E8E8' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })} ... />
export function styleguideImgPlaceholder(p: StyleguidePlaceholderProps): string {
  return `data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" width="${p.shape.width}" height="${p.shape.height}" viewBox="0 0 ${p.shape.width} ${p.shape.height}"><rect rx="${p.shape.radius}" width="${p.shape.width}" height="${p.shape.height}" x="0" y="0" fill="${encodeURIComponent(p.shape.bgColor)}"/> ${p.text && (`<text style="color: ${encodeURIComponent(p.text.color)}; font-size: ${(fontSize(p))}px;${p.text.font && (` font-family: ${p.text.font};`)}" x="50%" y="50%" dominant-baseline="middle" text-anchor="middle">${p.shape.width} x ${p.shape.height}</text>`)}</svg>`
}

export const pxToRem = (value: number) => `${Number((value / 16).toFixed(3))}rem`
export const floatTwo = (value: number) => Number((value).toFixed(2))
